import { ThemeDto } from "./dtos";

const Config = {
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN!,
    clientId: process.env.REACT_APP_AUTH0_CLIENTID!,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
    // audience: "https://popivnenko.com",
    roles_claims: process.env.REACT_APP_AUTH0_ROLES_CLAIMS!,
    user_medatata_claims: process.env.REACT_APP_AUTH0_USER_MEDATATA_CLAIMS!,
    is_free_plan: process.env.REACT_APP_AUTH0_FREE_PLAN === "1"
  },
  apiRoot: process.env.REACT_APP_APIROOT!,
  showAiControls: process.env.REACT_APP_SHOW_AI_CONTROLS === 'true',
  showServicesMenu: process.env.REACT_APP_SHOW_SERVICES_MENU !== 'false',
  forumUrl: process.env.REACT_APP_FORUM_URL?.trim() ?? '',
  allowOrderCertificates: process.env.REACT_APP_ALLOW_ORDER_CERTIFICATES === 'true',
  showBreadcrumbs: process.env.REACT_APP_SHOWBREADCRUMBS! === 'true',
  env: process.env.REACT_APP_ENV!,
  app_name: process.env.REACT_APP_NAME!,
};

const RouteMap: Record<string, string> = {
  '/': 'Home',
  '/products': 'Products',
  '/pricing': 'Pricing',
  '/services': 'Services',
  '/reviews': 'Reviews',
  '/about': 'About',
  '/profile': 'Profile',
  "/admin/activities": 'Activities',
  '/admin/users': 'Users',
  '/admin/modules': 'Modules',
  '/admin/protectedStorage': 'Protected storage',
  '/terms-of-use': 'Terms & conditions',
  '/privacy-policy': 'Privacy Policy',
  '/refund-policy': 'Refund & cancellation policy',
  '/admin/courses': 'Courses',
  '/admin/certificates': 'Certificates',
  '/admin/reviews': 'Review moderation',
  '/admin/analytics': 'Learning analytics',
  '/admin/tasks': 'Admin tasks',
  '/admin/finance': 'Finance',
  "/admin/help": 'Help',
  '/admin/debug': 'Debug',
};

const Themes: ThemeDto[] = [
  { label: 'Arya Blue', value: 'arya-blue' },
  { label: 'Arya Green', value: 'arya-green' },
  { label: 'Arya Orange', value: 'arya-orange' },
  { label: 'Arya Purple', value: 'arya-purple' },
  { label: 'Bootstrap4 Dark Blue', value: 'bootstrap4-dark-blue' },
  { label: 'Bootstrap4 Dark Purple', value: 'bootstrap4-dark-purple' },
  { label: 'Bootstrap4 Light Blue', value: 'bootstrap4-light-blue' },
  { label: 'Bootstrap4 Light Purple', value: 'bootstrap4-light-purple' },
  { label: 'Fluent Light', value: 'fluent-light' },
  { label: 'Lara Dark Amber', value: 'lara-dark-amber' },
  { label: 'Lara Dark Blue', value: 'lara-dark-blue' },
  { label: 'Lara Dark Cyan', value: 'lara-dark-cyan' },
  { label: 'Lara Dark Green', value: 'lara-dark-green' },
  { label: 'Lara Dark Indigo', value: 'lara-dark-indigo' },
  { label: 'Lara Dark Pink', value: 'lara-dark-pink' },
  { label: 'Lara Dark Purple', value: 'lara-dark-purple' },
  { label: 'Lara Dark Teal', value: 'lara-dark-teal' },
  { label: 'Lara Light Amber', value: 'lara-light-amber' },
  { label: 'Lara Light Blue', value: 'lara-light-blue' },
  { label: 'Lara Light Cyan', value: 'lara-light-cyan' },
  { label: 'Lara Light Green', value: 'lara-light-green' },
  { label: 'Lara Light Indigo', value: 'lara-light-indigo' },
  { label: 'Lara Light Pink', value: 'lara-light-pink' },
  { label: 'Lara Light Purple', value: 'lara-light-purple' },
  { label: 'Lara Light Teal', value: 'lara-light-teal' },
  { label: 'Luna Amber', value: 'luna-amber' },
  { label: 'Luna Blue', value: 'luna-blue' },
  { label: 'Luna Green', value: 'luna-green' },
  { label: 'Luna Pink', value: 'luna-pink' },
  { label: 'Material Dark Deep Purple', value: 'md-dark-deeppurple' },
  { label: 'Material Dark Indigo', value: 'md-dark-indigo' },
  { label: 'Material Light Deep Purple', value: 'md-light-deeppurple' },
  { label: 'Material Light Indigo', value: 'md-light-indigo' },
  { label: 'Material Design Dark Deep Purple', value: 'mdc-dark-deeppurple' },
  { label: 'Material Design Dark Indigo', value: 'mdc-dark-indigo' },
  { label: 'Material Design Light Deep Purple', value: 'mdc-light-deeppurple' },
  { label: 'Material Design Light Indigo', value: 'mdc-light-indigo' },
  { label: 'Mira', value: 'mira' },
  { label: 'Nano', value: 'nano' },
  { label: 'Nova', value: 'nova' },
  { label: 'Nova Accent', value: 'nova-accent' },
  { label: 'Nova Alt', value: 'nova-alt' },
  { label: 'Rhea', value: 'rhea' },
  { label: 'Saga Blue', value: 'saga-blue' },
  { label: 'Saga Green', value: 'saga-green' },
  { label: 'Saga Orange', value: 'saga-orange' },
  { label: 'Saga Purple', value: 'saga-purple' },
  { label: 'Soho Dark', value: 'soho-dark' },
  { label: 'Soho Light', value: 'soho-light' },
  { label: 'Tailwind Light', value: 'tailwind-light' },
  { label: 'Vela Blue', value: 'vela-blue' },
  { label: 'Vela Green', value: 'vela-green' },
  { label: 'Vela Orange', value: 'vela-orange' },
  { label: 'Vela Purple', value: 'vela-purple' },
  { label: 'Viva Dark', value: 'viva-dark' },
  { label: 'Viva Light', value: 'viva-light' },
];

export default Config;
export { RouteMap, Themes };
